module.exports = __webpack_public_path__ + "static/success-do-example-7087cbd984db5e23fecc9b2790520b8f.svg";